import type { ColorArray } from '../types/utils';

export const RacemapColors = {
  CloudBlue: '#ced9e3',
  PaleBlue: '#36739a',
  LightBlue: '#f0f5fa',
  DarkRed: '#721c25',
  DangerRed: '#FF4D4F',
  DustRed1: '#fff1f0',
  DustRed2: '#ffccc7',
  BaseRed: '#ff4646',
  AltRed: '#f53838',
  LightRed: '#f8d7da',
  LightLightRed: '#fef2f2',
  LightYellow: '#fcda9f',
  LightLightYellow: '#fefbea',
  BaseYellow: '#ffff00',
  LightLightGreen: '#f6ffed',
  LightGreen: '#b7eb8f',
  BaseGreen: '#52c41a',
  DarkGreen: '#008000',
  PolarGreen1: '#f6ffed',
  PolarGreen2: '#d9f7be',
  LightGray: '#dee2e6',
  LightLightGray: '#f2f2f2',
  LightLightLightGray: '#fafafa',
  Gray: '#ced4da',
  DarkGray: '#646464',
  DarkYellow: '#d4b106',
  SunriseYellow1: '#feffe6',
  SunriseYellow2: '#ffffb8',
  DarkBlue: '#254a61',
  LightOrange: '#ffa500',
  LightLightOrange: '#fffcf1',
  Orange: '#b4530a',
  DarkDarkGray: '#202020',
  GoldenBrown: '#d48806',
  Headline: '#404040',
  ChartBlue: '#5470c6',
  ChartGreen: '#91cc75',
  ChartYellow: '#fac858',
};

export const DefaultColorArray: ColorArray = [54, 115, 154, 255];
export const DefaultColorArraySplit: ColorArray = [54, 115, 0, 255];
export const DefaultColorObject = {
  r: 54,
  g: 115,
  b: 154,
  a: 1,
};

export const RacemapPlayStoreLink = 'https://play.google.com/store/apps/details?id=racemap.de';
export const RacemapAppStoreLink = 'https://apps.apple.com/us/app/racemap/id640797527';

export const RacemapOrgaPlayStoreLink =
  'https://play.google.com/store/apps/details?id=com.racemap.orga.app&pcampaignid=web_share';
export const RacemapOrgaAppStoreLink = 'https://apps.apple.com/us/app/racemap-orga/id1668767086';

// based on bootstrap breakpoints (min-width: 992px)
export const MaxMobileWindowWidth = 991;
